<template>
  <div>
    <p class="mb-4">CurriculumFinder puts searchable academic catalogs at your fingertips.</p>
    <p class="mb-4">
      Start by typing a school name in the search box on the left, or switch to
      <strong>Filter &amp; sort</strong> to browse institutions by state, level
      and control. Then pick an academic year to open the catalog.
    </p>
    <p class="mb-4"><strong>Web Catalogs:</strong> Web catalogs will automatically open a new tab on the college's catalog site.</p>
    <p class="mb-4"><strong>PDF Catalogs:</strong> Type in the search term. The Search Term can be any keyword, phrase or course identifier. For example "Credit for Prior Learning"; "General Education", "Tuition"</p>
    <p class="mb-2"><strong>Course searching:</strong> Use the complete or partial title, subject codes and numbers or keywords in
      descriptions. The more specific the search, the narrower the results. NOTE Course subject code +
      number combinations in catalogs may not use the same punctuation as the transcript.</p>
  </div>
</template>

<script>
export default {
  name: 'IntroContent',
}
</script>
